import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { Link } from 'react-router'
import { compose } from 'redux'
import withSeparateAuthFlow from '../hoc/separate-auth-flow'
import withFacebookLogin from '../hoc/facebook-login'
import { publishTracking } from '../../services/tracking'
import Google from '../social/google/google'
import Facebook from '../social/facebook/facebook'
import Twitter from '../social/twitter/twitter'
import ErrorPopup from '../error-popup/error-popup'
import MoreDetails from '../sign-in/more-details'
import './sign-up.css'
import {
  GOOGLE_LOGIN_PENDING,
  TWITTER_LOGIN_PENDING,
  CLEAR_GOOGLE_ERROR,
  CLEAR_TWITTER_ERROR,
} from '../../actions'

class SignUp extends Component {
  responseTwitterLogin = (response) => {
    this.props.handleAction(TWITTER_LOGIN_PENDING, {
      isRedirectFlow: !!this.props.redirectUri,
      ...response,
    })
  }

  responseGoogleLogin = (response) => {
    this.props.handleAction(GOOGLE_LOGIN_PENDING, {
      isRedirectFlow: !!this.props.redirectUri,
      ...response,
    })
  }

  googleErrorHandler = () => {
    if (this.props.googleError !== '') {
      setTimeout(() => this.props.handleAction(CLEAR_GOOGLE_ERROR), 30000)
      return this.props.googleError
    }
    return ''
  }

  twitterErrorHandler = () => {
    if (this.props.twitterError !== '') {
      setTimeout(() => this.props.handleAction(CLEAR_TWITTER_ERROR), 30000)
      return this.props.twitterError
    }
    return ''
  }

  overlayClickTracker = (e) => {
    if (!this.props.redirectUri) {
      publishTracking({
        userAction: 'join with',
        origin: 'facebook',
        event: 'event144',
      })
    }
    // eslint-disable-next-line
    ReactDOM.findDOMNode(this.facebookButton).click()
  }

  clickTracker = (origin) => {
    if (!this.props.redirectUri) {
      publishTracking({
        userAction: 'join with',
        origin: origin,
        event: 'event144',
      })
    }
  }

  loginHandler = () => {
    if (!this.props.redirectUri) {
      publishTracking({
        userAction: 'drawer: sign in',
        event: 'event97',
      })
    }
  }

  render() {
    const { t, missingFields, clientId, provider, providerSecret, providerToken, handleAction } = this.props
    const facebookError = this.props.facebookErrorHandler()
    const twitterError = this.twitterErrorHandler()
    const googleError = this.googleErrorHandler()

    /* eslint-disable */
    return (
      <div className="sign-up-page xs-flex xs-justify-center xs-items-center xs-fill-gray-lighter">

        {missingFields.length > 0 &&
          <MoreDetails
            t={t}
            missingFields={missingFields}
            clientId={clientId}
            provider={provider}
            providerSecret={providerSecret}
            providerToken={providerToken}
            handleAction={handleAction}
            facebookError={facebookError}
            googleError={googleError}
            twitterError={twitterError}
          />
        }

        {missingFields.length === 0 &&
          <div className="auth-modal xs-py3 xs-px4 xs-col-12">
            <div className="modal-header xs-text-center">
              <div className="modal-header__title xs-text-3 xs-px5 xs-mb2">{t('HEADER_TITLE')}</div>
            </div>

            <div className="modal-content">
              <div className="xs-overflow-hidden rounded">
                <div className="xs-relative">
                  <div className="xs-absolute xs-t0 xs-b0 xs-l0 xs-r0 xs-z1 cursor-pointer" onMouseUp={this.overlayClickTracker} />
                  <Facebook
                    ref={c => this.facebookButton = c}
                    buttonText={t('JOIN_FB')}
                    onLoginResponse={this.props.facebookLoginResponse}
                  />
                </div>
                <div onClick={() => this.clickTracker('twitter')}>
                  <Twitter
                    buttonText={t('JOIN_TW')}
                    onLoginResponse={this.responseTwitterLogin}
                  />
                </div>
                <div onClick={() => this.clickTracker('google')}>
                  <Google
                    buttonText={t('JOIN_GG')}
                    onLoginResponse={this.responseGoogleLogin}
                  />
                </div>

                <Link to="/emailsignup" onClick={() => this.clickTracker('time out')}>
                  <button className="join-with em xs-border-none xs-block">
                    <span className="join-text xs-pt4 xs-pl4 xs-float-left xs-text-white">{t('JOIN_EM')}</span>
                    <span className="em-logo xs-float-right xs-mx3 xs-my4" />
                  </button>
                </Link>
              </div>
            </div>

            <div className="modal-footer xs-text-7 xs-text-center">
              <div className="xs-mt5">{t('ALREADY_HAVE')}&nbsp;
              <Link to={"/signin" + this.props.location.search} onClick={this.loginHandler}
                  className="xs-text-red cursor-pointer" data-test-id="login">{t('CREATE_ACCOUNT_LOG_IN')}</Link>
              </div>
            </div>
          </div>
        }

      </div>
    )
    /* eslint-enable */
  }
}

SignUp.propTypes = {
  handleAction: PropTypes.func,
  t: PropTypes.func.isRequired,
  googleError: PropTypes.string,
  twitterError: PropTypes.string,
  missingFields: PropTypes.arrayOf(PropTypes.string),
  clientId: PropTypes.string,
  provider: PropTypes.string,
  providerSecret: PropTypes.string,
  providerToken: PropTypes.string,
  facebookLoginResponse: PropTypes.func,
  facebookErrorHandler: PropTypes.func,
  redirectUri: PropTypes.string,
}

SignUp.defaultProps = {
  handleAction: PropTypes.func,
  googleError: '',
  twitterError: '',
  missingFields: [],
  clientId: '',
  provider: '',
  providerSecret: '',
  providerToken: '',
  facebookLoginResponse: PropTypes.func,
  facebookErrorHandler: PropTypes.func,
  redirectUri: null,
}

export default compose(
  withSeparateAuthFlow,
  withFacebookLogin,
)(SignUp)



// WEBPACK FOOTER //
// ./src/components/sign-up/sign-up.js